'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { Suspense, useEffect } from 'react'
import gtag, { isGoogleAnalyticsEnabled } from 'src/utils/gtag'

function PageViewTracker() {
    const pathname = usePathname()
    const searchParams = useSearchParams()
    useEffect(() => {
        if (!isGoogleAnalyticsEnabled()) {
            return
        }
        const query = searchParams.toString()
        const pagePath = query ? `${pathname}?${query}` : pathname
        gtag('event', 'page_view', {
            page_path: pagePath,
            page_location: window.location.href,
            page_title: document.title,
        })
    }, [pathname, searchParams])
    return null
}

export default function GoogleAnalytics() {
    // useSearchParams requires a Suspense boundary in the App Router,
    // otherwise it opts the whole tree into client-side rendering / errors at build.
    return (
        <Suspense fallback={null}>
            <PageViewTracker />
        </Suspense>
    )
}
